import Heading from '@/decodo/components/atoms/Heading';
import NextImage from '@/decodo/components/atoms/Image';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import { Text } from '@/decodo/components/atoms/Text';
import { getWrapperMaxWidth } from '@/features/utils/utils';
import { cn } from '@/lib/utils';
import React from 'react';

export type BackgroundImageHeroLink = {
  label: string;
  href: string;
};

export type BackgroundImageHeroProps = {
  title: string;
  description: React.ReactNode;
  links: BackgroundImageHeroLink[];
};

export function HeroWithBackgroundImage({
  links,
  title,
  description,
}: BackgroundImageHeroProps) {
  return (
    <section
      data-tracker-section='hero-with-background-image'
      className='md:py-15 md:px-15 bg-gray-25 dark relative flex justify-center bg-cover bg-center p-5 py-8'
    >
      <NextImage
        aria-hidden
        src='/svg/RainbowWave.svg'
        alt=''
        classNames={{
          container: 'absolute inset-0 hidden md:block',
          image: 'w-full h-full',
        }}
        objectFit='cover'
      />
      <div
        className={cn(
          getWrapperMaxWidth('mid'),
          'md:bg-gray-dark-950/50 static z-10 w-full md:px-5 md:py-8 md:text-center md:backdrop-blur-[4px]'
        )}
      >
        <Heading
          level='h1'
          classNames={{
            root: 'text-h2 md:text-h1 lg:text-l mb-5 md:mb-6 text-base-dark-white',
          }}
        >
          {title}
        </Heading>
        <Text className='text-gray-dark-400 pb-3 md:pb-0'>{description}</Text>
        <div
          className='flex flex-col justify-center gap-x-6 md:flex-row'
          data-tracker-component='actions'
        >
          {links.map((item, index) => (
            <div key={index} className='light pt-5 md:pt-9'>
              {1 === index ? (
                <>
                  <LinkButton
                    href={item.href}
                    variant='outlined'
                    color='white'
                    fullwidth={true}
                  >
                    {item.label}
                  </LinkButton>
                </>
              ) : (
                <div className='pt-3 md:pt-0'>
                  <LinkButton
                    href={item.href}
                    variant='filled'
                    color='white'
                    fullwidth={true}
                  >
                    {item.label}
                  </LinkButton>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
